import React from 'react';
import PropTypes from 'prop-types';
import Alert from '@material-ui/lab/Alert';
import moment from 'logic/moment';
import { FormattedMessage } from 'react-intl';

import {
  Paper,
  withStyles,
  withMobileDialog,
} from '@material-ui/core';

import CircularProgress from 'components/shared/CircularProgress';
import AddReviewForm from './AddReviewForm';

const year = moment().format('Y');

const styles = (theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
});

const ReviewAdd = ({
  classes,
  cottageId,
  isUpdating,
  initialStars,
  isLoading,
  canLeaveReview,
  alreadyReviewed,

  sendReview,
}) => {
  if (isLoading) {
    return (
      <CircularProgress />
    );
  }

  if (alreadyReviewed) {
    return (
      <Paper className={classes.paper}>
        <Alert severity="error" elevation={3}>
          <FormattedMessage
            id="reviews.alreadyReviewed"
            defaultMessage="You have already left a review for this booking"
          />
        </Alert>
      </Paper>
    );
  }

  if (!canLeaveReview) {
    return (
      <Paper className={classes.paper}>
        <Alert severity="error" elevation={3}>
          <FormattedMessage
            id="reviews.notAllowed"
            defaultMessage="You are not allowed to leave a review for this ad"
          />
        </Alert>
      </Paper>
    );
  }

  return (
    <Paper className={classes.paper}>
      <AddReviewForm
        cottageId={cottageId}
        initialValues={{
          year,
          score: parseInt(initialStars, 10) || null,
          body: '',
        }}
        isUpdating={isUpdating}
        sendReview={sendReview}
      />
    </Paper>
  );
};

ReviewAdd.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  cottageId: PropTypes.string,
  isLoading: PropTypes.bool,
  isUpdating: PropTypes.bool,
  initialStars: PropTypes.string,
  canLeaveReview: PropTypes.bool,
  alreadyReviewed: PropTypes.bool,

  sendReview: PropTypes.func.isRequired,
};

export default withStyles(styles)(withMobileDialog()(ReviewAdd));
